import React, { PropsWithChildren } from 'react'
import { useFeatureFlags } from '@node-space/hooks'
import NotFound from 'pages/NotFound'
import { FeatureFlagsNamed } from 'types/types'
import AppLoader from './AppLoader'

export interface FeatureProtectedPageProps extends PropsWithChildren {
  feature: keyof FeatureFlagsNamed
}

export const FeatureProtectedPage = ({ feature, children }: FeatureProtectedPageProps) => {
  const featureFlags = useFeatureFlags()
  const featureFlagValue = featureFlags?.[feature]

  if (typeof featureFlagValue !== 'boolean') {
    return <AppLoader />
  }

  return featureFlagValue ? children : <NotFound />
}
